module.exports = __webpack_public_path__ + "img/blog6.5f166410.jpg";